import { render, staticRenderFns } from "./SearchResultSuggestedProducts.vue?vue&type=template&id=f7c68bde&"
import script from "./SearchResultSuggestedProducts.vue?vue&type=script&lang=ts&"
export * from "./SearchResultSuggestedProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports